import Go from './Go';

function App() {
  return <Go />;
}

export default App;
